import {BILL_TODO_TYPE_LABELS} from '../../types/enums.ts';
import {cn} from '../../lib/utils.ts';
import type {BillTodoType} from '../../generated/enums.ts';

const TODO_STYLES: Record<BillTodoType, string> = {
    possible_duplicate: 'bg-[#FBE4E4] text-[#8C2F2F] ring-[#F5CFCF]',
    transitory_schedule: 'bg-[#DDEBF7] text-[#1C3D5A] ring-[#C5DCEF]',
    before_bookkeeping_start: 'bg-[#FDECC8] text-[#6B4C13] ring-[#F7DFA6]',
};

const TAG_CLASS = 'inline-flex items-center rounded-full px-3 py-0.5 text-[10px] font-bold ring-1 ring-inset whitespace-nowrap';

type BillTodoTagProps = {
    todoType: BillTodoType;
    onClick?: () => void;
};

export function BillTodoTag({todoType, onClick}: BillTodoTagProps) {
    if (onClick) {
        return (
            <button
                type="button"
                aria-haspopup="dialog"
                data-testid={`bill-todo-tag-${todoType}`}
                onClick={(event) => {
                    event.stopPropagation();
                    onClick();
                }}
                className={cn(TAG_CLASS, TODO_STYLES[todoType], 'hover:opacity-80 focus:outline-none focus-visible:ring-2')}
            >
                {BILL_TODO_TYPE_LABELS[todoType]}
            </button>
        );
    }
    return (
        <span className={cn(TAG_CLASS, TODO_STYLES[todoType])}>
            {BILL_TODO_TYPE_LABELS[todoType]}
        </span>
    );
}
